import { api } from "../App";
import { SET_EVENTS_LIST, SET_EVENT, SET_EVENT_CLASSES, SET_EVENT_MEMBERS, SET_EVENT_CLASSES_WITH_MEMBERS } from "./types";




export const getEventClasses = (date_from, parallel) => async (dispatch, getState) => {
  try {
    const params = {};
    if (date_from) params.beg_date = date_from;
    if (parallel) params.parallel = parallel;
    const { data } = await api.get(`/events_news/filter/classes`, { params });
    dispatch({ type: SET_EVENT_CLASSES, payload: data.data });
  } catch (ERR) {
  } finally {
  }
}

export const getEventsList = (queryParams) => async (dispatch, getState) => {
  try {
    const params = Object.fromEntries(
      Object.entries(queryParams || {}).filter(([, v]) => v !== false && v !== null && v !== undefined && v !== '' && v !== 0)
    )
    const { data } = await api.get(`/events_news`, { params });
    dispatch({ type: SET_EVENTS_LIST, payload: data.data });
  } catch (ERR) {
  } finally {
  }
}

/// приходит что-то, но без списка ответственных
export const getEventById = (id_event) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/events_news/${id_event}`);
    dispatch({ type: SET_EVENT, payload: data });
  } catch (ERR) {
  } finally {
  }
}

export const addResponsible = (data, filters) => async (dispatch, getState) => {
  try {
    await api.post(`/events_news_stuff/responsible`, data)
    dispatch(getEventsList(filters))
  } catch (ERR) {
  } finally {
  }
}

export const deleteResponsible = (id, filters) => async (dispatch, getState) => {
  try {
    await api.delete(`/events_news_stuff/responsible/${id}`)
    dispatch(getEventsList(filters))
  } catch (ERR) {
  } finally {
  }
}
export const addParticipantsEmployees = (data, filters) => async (dispatch, getState) => {
  try {
    await api.post(`/events_news_stuff/participants`, data)
    dispatch(getEventsList(filters))
  } catch (ERR) {
  } finally {
  }
}

export const deleteParticipantsEmployees = (id, filters) => async (dispatch, getState) => {
  try {
    await api.delete(`/events_news_stuff/participants/${id}`)
    dispatch(getEventsList(filters))
  } catch (ERR) {
  } finally {
  }
}

export const addParticipant = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/events_news_stuff/participants`, data)
  } catch (ERR) {
  } finally {
  }
}

export const deleteParticipant = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/events_news_stuff/participants/${id}`)
  } catch (ERR) {
  } finally {
  }
}


export const createEvent = (data, filters, force) => async (dispatch, getState) => {
  try {
    await api.post('/events_news', data, { params: force ? { force: true } : undefined });
    await dispatch(getEventsList(filters))
    return { success: true }
  } catch (ERR) {
    if (ERR?.response?.status === 409) {
      return { success: false, conflict: true, message: ERR.response.data?.message, conflicts: ERR.response.data?.conflicts || [] }
    }
    return { success: false }
  }
}

export const updateEvent = (id, data, filters, force) => async (dispatch, getState) => {
  try {
    await api.put(`/events_news/${id}`, data, { params: force ? { force: true } : undefined });
    await dispatch(getEventsList(filters))
    return { success: true }
  } catch (ERR) {
    if (ERR?.response?.status === 409) {
      return { success: false, conflict: true, message: ERR.response.data?.message, conflicts: ERR.response.data?.conflicts || [] }
    }
    return { success: false }
  }
}

// export const deleteEventLevel = (id) => async (dispatch, getState) => {
//   try {
//     dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: true });
//     await api.delete(`/news_levels/${id}`);
//     await dispatch(getEventLevels())
//   } catch (ERR) {
//   } finally {
//     dispatch({ type: SET_EVENT_LEVELS_LOADING, payload: false });
//   }
// }

// Получение классов мероприятия с признаком участия
export const getEventClassesById = (nid) => async (dispatch) => {
  try {
    const { data } = await api.get(`/events_news/${nid}/classes`);
    dispatch({ type: SET_EVENT_CLASSES_WITH_MEMBERS, payload: data });
  } catch (ERR) {
    console.error('Error fetching event classes:', ERR);
  }
}

// Получение участников мероприятия
export const getEventMembers = (xp_key, mid) => async (dispatch) => {
  try {
    // const { data } = await api.get(`/events_news/${nid}/members`);
    const { data } = await api.get(`/events_participants_api/${xp_key}/${mid}`);
    dispatch({ type: SET_EVENT_MEMBERS, payload: data });
  } catch (ERR) {
    console.error('Error fetching event members:', ERR);
  }
}

// Добавление участника-ученика
export const addEventMember = (nid, memberData) => async (dispatch) => {
  try {
    await api.post(`/events_news/${nid}/members`, memberData);
    await dispatch(getEventMembers(nid));
  } catch (ERR) {
    console.error('Error adding event member:', ERR);
  }
}

// Удаление участника-ученика
export const deleteEventMember = (nid, memberId) => async (dispatch) => {
  try {
    await api.delete(`/events_news/${nid}/members/${memberId}`);
    await dispatch(getEventMembers(nid));
  } catch (ERR) {
    console.error('Error deleting event member:', ERR);
  }
}

// Обновление участника (план/факт/призер/победитель и т.д.)
export const updateEventMember = (nid, memberId, memberData) => async (dispatch) => {
  try {
    await api.put(`/events_news/${nid}/members/${memberId}`, memberData);
    await dispatch(getEventMembers(nid));
  } catch (ERR) {
    console.error('Error updating event member:', ERR);
  }
}

// Массовое добавление/обновление классов мероприятия
export const updateEventClasses = (nid, classIds) => async (dispatch) => {
  try {
    await api.post(`/events_news/${nid}/classes`, { classes: classIds });
    await dispatch(getEventClassesById(nid));
  } catch (ERR) {
    console.error('Error updating event classes:', ERR);
  }
}

// Удаление мероприятия
export const deleteEvent = (nid, filters) => async (dispatch) => {
  try {
    await api.delete(`/events_news/${nid}`);
    await dispatch(getEventsList(filters));
  } catch (ERR) {
    console.error('Error deleting event:', ERR);
  }
}

// Обновление участника-сотрудника (призер/победитель)
export const updateParticipantEmployee = (pmbid, data, filters) => async (dispatch) => {
  try {
    await api.put(`/events_news_stuff/participants/${pmbid}`, data);
    await dispatch(getEventsList(filters));
  } catch (ERR) {
    console.error('Error updating participant employee:', ERR);
  }
}